import React, { useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Snackbar, Alert, Box, MenuItem, TextField, InputAdornment, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import styled from "@emotion/styled";
// import { RTOContext } from "../../Context/RTOContext";


const MainContainer = styled(Box)`
  display: grid;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 40px 0;
  gap: 20px;
`;

const FieldContainer = styled(Box)`
  width: 100%;
  display: flex;
  gap: 20px;
  align-items: center;
`;

const IconButtonStyle = styled(IconButton)`
  background: none;
  width: 49px;
  height: 49px;
  margin: 5px 0px 5px 5px;
  &:hover {
    background: black;
    color: white;
  }
`;

const RTOForm = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  // const navigate = useNavigate();
  // const [openSnackbar, setOpenSnackbar] = useState(false);
  // const { submitRTO } = useContext(RTOContext);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const marketPlaces = [
    "Amazon", "Flipkart", "Meesho", "FirstCry", "Pluugin Store"
  ]

  const couriers = [
    "Delhivery", "Blue Dart", "Valmo", "Shadowfax", "Xpress Bees",
    "Amazon", "Flipkart", "Tata 1mg", "Hyugai Life", "Nimbus",
    "DTDC", "Meolaa"
  ];

  const itemCondition = ["Good", "Damaged", "Missing", "Wrong Return", "Used"];

  // Single source of truth for all rows
  const [fields, setFields] = useState([
    {
      marketplaces: "",
      pickupPartner: "",
      returnDate: "",
      skuCode: "",
      productTitle: "",
      awbId: "",
      orderId: "",
      orderDate: "",
      returnQty: "",
      itemCondition: "",
      claimRaised: "",
      ticketId: "",
      comments: "",
    },
  ]);

  const awbTimers = useRef({});
  const inputRefs = useRef([]);

  const [loading, setLoading] = useState(false);

  const addField = () => {
    setFields((prev) => {
      const updated = [
        ...prev,
        {
          marketplaces: "",
          pickupPartner: "",
          returnDate: "",
          skuCode: "",
          productTitle: "",
          awbId: "",
          orderId: "",
          orderDate: "",
          returnQty: "",
          itemCondition: "",
          claimRaised: "",
          ticketId: "",
          comments: "",
        },
      ];

      setTimeout(() => {
        inputRefs.current[updated.length - 1]?.focus();
      }, 100);

      return updated;
    });
  };

  // Delete specific row
  const removeField = (index) => {
    setFields((prev) => prev.filter((_, i) => i !== index));
  };

  // Handle field changes
  const handleChange = (index, key, value) => {
    setFields((prevFields) => {
      const updatedFields = [...prevFields];
      if (!updatedFields[index]) return prevFields;

      updatedFields[index] = { ...updatedFields[index], [key]: value };
      return updatedFields;
    });

    if (key === "skuCode") {
      const timer = setTimeout(() => fetchSkuData(value, index), 500);
      return () => clearTimeout(timer);
    }
  };

  // Fetch SKU data and update product title
  const fetchSkuData = async (code, index) => {
  try {
    const res = await axios.get(`${API_URL}/api?type=skuCode&skuCode=${code}`);

    setFields((prevFields) => {
      if (!prevFields[index]) return prevFields;

      const updatedFields = [...prevFields];

      const title = res.data.success ? res.data.data.sku?.name || "" : "";

      updatedFields[index] = {
        ...updatedFields[index],
        productTitle: title,
        isValidSku: res.data.success,
      };

      return updatedFields;
    });
  } catch (err) {
    setFields((prevFields) => {
      if (!prevFields[index]) return prevFields;

      const updatedFields = [...prevFields];
      updatedFields[index] = {
        ...updatedFields[index],
        productTitle: "",
        isValidSku: false,
      };

      return updatedFields;
    });
  }
};

// Fetch Data with Awb id
  // const fetchAwbData = async (awbId, index) => {
  //   if (!awbId) return;

  //   try {
  //     const toInputDate = (val) => {
  //       if (!val) return "";

  //       if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
        
  //       if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
  //         const [dd, mm, yyyy] = val.split("-");
  //         return `${yyyy}-${mm}-${dd}`;
  //       }
  //       const d = new Date(val);
  //       return isNaN(d) ? "" : d.toISOString().split("T")[0];
  //     };

  //     // 🔹 Try Meesho first
  //     try {
  //       const res = await axios.get(`${API_URL}/api/meesho-rto/${awbId}`);
  //       const rto = res.data?.data;
  //       if (rto) {
  //         setFields((prev) => {
  //           const updated = [...prev];
  //           updated[index] = {
  //             ...updated[index],
  //             marketplaces: "Meesho",
  //             pickupPartner: rto.courier_partner || "",
  //             returnDate: toInputDate(rto.return_date),
  //             awbId,
  //             skuCode: rto.sku || "",
  //             productTitle: rto.product_name || "",
  //             orderId: rto.order_number || "",
  //             orderDate: toInputDate(rto.dispatch_date),
  //             returnQty: rto.qty || "",
  //           };
  //           return updated;
  //         });
  //         setSnackbar({
  //           open: true,
  //           message: `AWB ${awbId} data loaded`,
  //           severity: "success",
  //         });
  //         return;
  //       }
  //     } catch (_) {
  //       // ignore Meesho 404s
  //     }

  //     // 🔹 Try Amazon next
  //     try {
  //       const res = await axios.get(`${API_URL}/api/amazon-rto/${awbId}`);
  //       const rto = res.data?.data;
  //       if (rto) {
  //         setFields((prev) => {
  //           const updated = [...prev];
  //           updated[index] = {
  //             ...updated[index],
  //             marketplaces: "Amazon",
  //             pickupPartner: rto.return_carrier || "",
  //             returnDate: toInputDate(rto.return_delivery_date),
  //             awbId,
  //             skuCode: rto.merchant_sku || "",
  //             productTitle: rto.item_name || "",
  //             orderId: rto.order_id || "",
  //             orderDate: toInputDate(rto.order_date),
  //             returnQty: rto.return_quantity || "",
  //           };
  //           return updated;
  //         });
  //         setSnackbar({
  //           open: true,
  //           message: `AWB ${awbId} data loaded`,
  //           severity: "success",
  //         });
  //         return;
  //       }
  //     } catch (_) {
  //       // ignore Amazon 404s
  //     }

  //     // 🔹 Try Flipkart finally
  //     try {
  //       const res = await axios.get(`${API_URL}/api/flipkart-rto/${awbId}`);
  //       const rto = res.data?.data;
  //       if (rto) {
  //         setFields((prev) => {
  //           const updated = [...prev];
  //           updated[index] = {
  //             ...updated[index],
  //             marketplaces: "Flipkart",
  //             pickupPartner: "Flipkart",
  //             returnDate: toInputDate(rto.return_approval_date),
  //             awbId: rto.tracking_id || awbId,
  //             skuCode: rto.sku || "",
  //             productTitle: rto.product || "",
  //             orderId: rto.order_id || "",
  //             orderDate: toInputDate(rto.out_for_delivery_date),
  //             returnQty: rto.quantity || "",
  //           };
  //           return updated;
  //         });
  //         setSnackbar({
  //           open: true,
  //           message: `AWB ${awbId} data loaded`,
  //           severity: "success",
  //         });
  //         return;
  //       }
  //     } catch (_) {
  //       // ignore Flipkart 404s
  //     }

  //     // 🔹 Not found anywhere
  //     setSnackbar({
  //       open: true,
  //       message: `No data found for AWB: ${awbId}`,
  //       severity: "warning",
  //     });
  //   } catch (err) {
  //     console.error("AWB Fetch Error:", err);
  //     setSnackbar({
  //       open: true,
  //       message: "Error fetching AWB/Order ID data.",
  //       severity: "error",
  //     });
  //   }
  // };

  const fetchAwbData = async (awbId, index) => {
    if (!awbId) return;

    const toInputDate = (val) => {
      if (!val) return "";
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;

      if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
        const [dd, mm, yyyy] = val.split("-");
        return `${yyyy}-${mm}-${dd}`;
      }

      const d = new Date(val);
      return isNaN(d) ? "" : d.toISOString().split("T")[0];
    };

    try {
      // 🚀 PARALLEL API CALLS
      const [meesho, amazon, flipkart] = await Promise.allSettled([
        axios.get(`${API_URL}/api/meesho-rto/${awbId}`),
        axios.get(`${API_URL}/api/amazon-rto/${awbId}`),
        axios.get(`${API_URL}/api/flipkart-rto/${awbId}`)
      ]);

      let rto = null;
      let source = "";

      // ✅ Priority: Meesho → Amazon → Flipkart
      if (meesho.status === "fulfilled" && meesho.value.data?.data) {
        rto = meesho.value.data.data;
        source = "Meesho";
      } 
      else if (amazon.status === "fulfilled" && amazon.value.data?.data) {
        rto = amazon.value.data.data;
        source = "Amazon";
      } 
      else if (flipkart.status === "fulfilled" && flipkart.value.data?.data) {
        rto = flipkart.value.data.data;
        source = "Flipkart";
      }

      // ❌ Not found
      if (!rto) {
        setSnackbar({
          open: true,
          message: `No data found for AWB: ${awbId}`,
          severity: "warning",
        });
        return;
      }

      // ✅ UPDATE UI (single setState → faster)
      setFields((prev) => {
        const updated = [...prev];

        if (source === "Meesho") {
          updated[index] = {
            ...updated[index],
            marketplaces: "Meesho",
            pickupPartner: rto.courier_partner || "",
            returnDate: toInputDate(rto.return_date),
            awbId,
            skuCode: rto.sku || "",
            productTitle: rto.product_name || "",
            orderId: rto.suborder_number || "",
            orderDate: toInputDate(rto.dispatch_date),
            returnQty: rto.qty || "",
          };
        }

        if (source === "Amazon") {
          updated[index] = {
            ...updated[index],
            marketplaces: "Amazon",
            pickupPartner: rto.return_carrier || "",
            returnDate: toInputDate(rto.return_delivery_date),
            awbId,
            skuCode: rto.merchant_sku || "",
            productTitle: rto.item_name || "",
            orderId: rto.order_id || "",
            orderDate: toInputDate(rto.order_date),
            returnQty: rto.return_quantity || "",
          };
        }

        if (source === "Flipkart") {
          updated[index] = {
            ...updated[index],
            marketplaces: "Flipkart",
            pickupPartner: "Flipkart",
            returnDate: toInputDate(rto.return_approval_date),
            awbId: rto.tracking_id || awbId,
            skuCode: rto.sku || "",
            productTitle: rto.product || "",
            orderId: rto.order_id || "",
            orderDate: toInputDate(rto.out_for_delivery_date),
            returnQty: rto.quantity || "",
          };
        }

        return updated;
      });

      // ✅ ONE snackbar
      setSnackbar({
        open: true,
        message: `AWB ${awbId} data loaded (${source})`,
        severity: "success",
      });

    } catch (err) {
      console.error("AWB Fetch Error:", err);
      setSnackbar({
        open: true,
        message: "Error fetching AWB data",
        severity: "error",
      });
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);

    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      await axios.post(
        `${API_URL}/api/rto`,
        { fields },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbar({
        open: true,
        message: "RTO submitted successfully!",
        severity: "success",
      });

      // Reset form
      setFields([
        {
          marketplaces: "",
          pickupPartner: "",
          returnDate: "",
          skuCode: "",
          productTitle: "",
          awbId: "",
          orderId: "",
          orderDate: "",
          itemCondition: "",
          claimRaised: "",
          ticketId: "",
          comments: "",
          returnQty: "",
        },
      ]);
    } catch (err) {
      console.error("Submit Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Auto-total return quantity
  const totalReturn = fields.reduce((acc, field) => {
    const qty = parseInt(field.returnQty, 10);
    return acc + (isNaN(qty) ? 1 : qty);
  }, 0);

  return (
    <div className="rto_form_stylin">
      <MainContainer component="form" onSubmit={handleSubmit}>
    
      {fields.map((field, index) => {
        const requiresClaim = ["Damaged", "Missing", "Wrong Return", "Used"].includes(field.itemCondition);

        return (
            <FieldContainer style={{ display: "grid" }} key={index}>
              {/* MARKETPLACE + PICKUP PARTNER + RETURN DATE */}
              <FieldContainer>
                <TextField
                  style={{ width: "30%" }}
                  select
                  label="Marketplaces"
                  value={field.marketplaces}
                  onChange={(e) =>
                    handleChange(index, "marketplaces", e.target.value)
                  }
                  required
                >
                  <MenuItem value="">
                    -- Select Marketplaces --
                  </MenuItem>
                  {marketPlaces.map((marketPlace, i) => (
                    <MenuItem key={i} value={marketPlace}>
                      {marketPlace}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  style={{ width: "34%" }}
                  select
                  label="Pickup Partner"
                  value={field.pickupPartner}
                  onChange={(e) =>
                    handleChange(index, "pickupPartner", e.target.value)
                  }
                  required
                >
                  <MenuItem value="">-- Select Courier --</MenuItem>
                  {couriers.map((courier, i) => (
                    <MenuItem key={i} value={courier}>
                      {courier}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  style={{ width: "34%" }}
                  type="date"
                  label="Return Date"
                  value={field.returnDate}
                  onChange={(e) =>
                    handleChange(index, "returnDate", e.target.value)
                  }
                  required
                  InputLabelProps={{ shrink: true }}
                />
              </FieldContainer>

            {/* SKU Code + Product Title */}
            <FieldContainer>
              <TextField
                style={{ width: "30%" }}
                label="SKU Code"
                variant="outlined"
                required
                value={field.skuCode}
                onChange={(e) => handleChange(index, "skuCode", e.target.value)}
                InputProps={{
                  endAdornment:
                    field.isValidSku && (
                      <InputAdornment position="end">
                        <CheckCircleIcon color="success" />
                      </InputAdornment> 
                    ),
                }}
              />

              <TextField
                style={{ width: "70%" }}
                label="Product Title"
                variant="outlined"
                value={field.productTitle}
                InputProps={{ readOnly: true }}
              />
            </FieldContainer>

            {/* AWB ID + Order ID + Date */}
            <FieldContainer>
              <TextField
                style={{ width: "32%" }}
                label="AWB ID"
                variant="outlined"
                required
                value={field.awbId}
                autoFocus={index === 0}
                inputRef={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => {
                  const value = e.target.value;
                  handleChange(index, "awbId", value);

                  if (value.length >= 8) {
                    if (awbTimers.current[index]) {
                      clearTimeout(awbTimers.current[index]);
                    }

                    awbTimers.current[index] = setTimeout(() => {
                      fetchAwbData(value, index);
                    }, 500);
                  }
                }}
              />
              <TextField
                style={{ width: "35%" }}
                label="Order ID"
                variant="outlined"
                value={field.orderId}
                onChange={(e) => handleChange(index, "orderId", e.target.value)}
              />
              <TextField
                style={{ width: "35%" }}
                type="date"
                label="Dispatched Date"
                variant="outlined"
                value={field.orderDate} 
                onChange={(e) => handleChange(index, "orderDate", e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </FieldContainer>

            {/* Item Condition + Claim + Ticket ID */}
            <FieldContainer>
              <TextField
                style={{ width: "29.5%" }}
                select
                label="Item Condition"
                variant="outlined"
                value={field.itemCondition}
                onChange={(e) => handleChange(index, "itemCondition", e.target.value)}
                required
              >
                <MenuItem value="">-- Select Condition --</MenuItem>
                {itemCondition.map((c, i) => (
                  <MenuItem key={i} value={c}>{c}</MenuItem>
                ))}
              </TextField>

              {requiresClaim && (
                <TextField
                  style={{ width: "32%" }}
                  select
                  label="Claim Raised"
                  value={field.claimRaised}
                  onChange={(e) => handleChange(index, "claimRaised", e.target.value)}
                  required
                >
                  <MenuItem value="">-- Select --</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              )}

              {requiresClaim && field.claimRaised === "Yes" && (
                <TextField
                  style={{ width: "32%" }}
                  label="Ticket ID"
                  value={field.ticketId}
                  onChange={(e) => handleChange(index, "ticketId", e.target.value)}
                  required
                />
              )}
            </FieldContainer>

            {/* Comments + Return Qty */}
            <FieldContainer>
            <TextField
              style={{ width: "70%", maxHeight: "80px" }}
              type="text"
              label="Comments"
              variant="outlined"
              value={field.comments}
              onChange={(e) => handleChange(index, "comments", e.target.value)}
              required={field.itemCondition !== "Good"}
            />
            <TextField
              style={{ width: "35%" }}
              type="number"
              label="Return Qty"
              variant="outlined"
              value={field.returnQty}
              onChange={(e) => handleChange(index, "returnQty", e.target.value)}
              required
            />
            </FieldContainer>

            {/* Add / Delete buttons */}
            <FieldContainer style={{ justifyContent: "center" }}>
              {index === fields.length - 1 && (
                <IconButtonStyle color="primary" onClick={addField}>
                  <AddIcon />
                </IconButtonStyle>
              )}
              {fields.length > 1 && (
                <IconButtonStyle color="error" onClick={() => removeField(index)}>
                  <DeleteIcon />
                </IconButtonStyle>
              )}
            </FieldContainer>
          </FieldContainer>
        );
      })}

      {/* Submit + Total Return */}
      <Box 
        style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center", 
          gap: "20px" 
        }}>
        <button 
          type="submit" 
          style={{ display: "flex", width: "70%" }} 
          className="learn-more"
          disabled={loading}
        >
          <span className="circle" aria-hidden="true">
            <span className="icon arrow"></span>
          </span>
          <span style={{ textTransform: "none" }} className="button-text">
            {loading ? "Submitting..." : "Submit RTO for Verification"}
          </span>
        </button>

        <TextField
          style={{ width: "35%" }}
          type="number"
          label="Total Return Qty"
          variant="outlined"
          value={totalReturn}
          InputProps={{ readOnly: true }}
        />
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert 
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </MainContainer>
    </div>
  );
};

export default RTOForm;
